import { render, staticRenderFns } from "./SponsorsEdit.vue?vue&type=template&id=6287e74e"
import script from "./SponsorsEdit.vue?vue&type=script&lang=js"
export * from "./SponsorsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports